import './app/zod-jitless.js';
import '@velora/tokens/theme.css';
import '@velora/ui/base.css';
import './app/app.css';
import { tokens as veloraTokens } from '@velora/tokens/skins/velora';
import { ensureSkinStylesheet } from '@velora/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.js';
import { startPwa } from './app/pwa/runtime.js';

// Velora Modern from the first paint (sign-in included); the employee's own
// mode replaces data-skin once the shell knows it.
ensureSkinStylesheet('velora', veloraTokens);

// Installable app: catch the browser's install prompt before sign-in and
// register the service worker (production builds only; src/pwa/sw.js).
startPwa({ register: import.meta.env.PROD });

const root = document.getElementById('root');
if (!root) throw new Error('missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
